import { NgModule } from '@angular/core';

import {
  PdBankDataComponent,
  PdBusinessDataComponent,
  PdCollectDataComponent,
  PdDocumentFileComponent,
  PdDocumentsComponent,
  PdSuccessComponent,
} from './components/pd-collect-data';
import { SharedModule } from '../shared/shared.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadModule } from 'primeng/fileupload';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { InputTextModule } from 'primeng/inputtext';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { DropdownModule } from 'primeng/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { DictionariesService, SellerService } from './http';
import { DictionaryItemTranslateModule } from '../shared/pipes/dictionary';

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild(),
    InputNumberModule,
    FileUploadModule,
    AngularSignaturePadModule,
    InputTextModule,
    NgxIntlTelInputModule,
    DropdownModule,
    DictionaryItemTranslateModule,
  ],
  providers: [SellerService, DictionariesService],
  declarations: [
    PdCollectDataComponent,
    PdBankDataComponent,
    PdBusinessDataComponent,
    PdDocumentsComponent,
    PdDocumentFileComponent,
    PdSuccessComponent,
  ],
  exports: [
    PdCollectDataComponent,
    PdBankDataComponent,
    PdBusinessDataComponent,
    PdDocumentsComponent,
    PdDocumentFileComponent,
    PdSuccessComponent,
  ],
})
export class SellerFeatureModule {}
